import { React, useState, useRef } from "react";

const EulaPopup = ({ onAgree }) => {
    const [agreed, setAgreed] = useState(false);
    const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);

    const scrollRef = useRef(null);

    const handleScroll = () => {
        const el = scrollRef.current;
        if (!el) return;

        const reachedBottom =
            el.scrollTop + el.clientHeight >= el.scrollHeight - 5;

        if (reachedBottom && !hasScrolledToBottom) {
            setHasScrolledToBottom(true);
        }
    };

    const eulaText = `
By using this application, you agree to the following terms:

This software is provided for use by authorized users only. It is intended solely for managing student pickup queues in a secure and efficient manner. You agree not to misuse, modify, or redistribute the application without written permission.

All data entered is handled securely and used only for operational purposes. The developers are not liable for any misuse, data loss, or operational delays resulting from use of this app.

This application relies on third-party cloud infrastructure, including services provided by Amazon Web Services (AWS). While we strive to maintain high availability and performance, we cannot guarantee uninterrupted service. You acknowledge and accept that temporary outages or disruptions may occur due to factors beyond our control, including but not limited to cloud service interruptions, internet connectivity issues, or force majeure events. The developers are not responsible for any damages, delays, or losses resulting from such interruptions.

By checking the box below, you acknowledge that you have read, understood, and agree to these terms.
`;

    return (
        <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: "#fff",
                padding: "2rem",
                borderRadius: "8px",
                maxWidth: "600px",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)"
            }}>
                <h2>📄 End User License Agreement</h2>

                <div
                    ref={scrollRef}
                    onScroll={handleScroll}
                    style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        paddingRight: "0.5rem",
                        marginBottom: "1rem",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#f9f9f9"
                    }}
                >
                    <p style={{ whiteSpace: "pre-wrap", padding: "1rem" }}>
                        {eulaText}
                    </p>
                </div>

                <label style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
                    <input
                        type="checkbox"
                        disabled={!hasScrolledToBottom}
                        checked={agreed}
                        onChange={() => setAgreed(!agreed)}
                        style={{ marginRight: "0.5rem" }}
                    />
                    {hasScrolledToBottom
                        ? "I agree to the terms above"
                        : "Scroll to the bottom to enable agreement"}
                </label>

                <button
                    onClick={() => agreed && onAgree()}
                    disabled={!agreed}
                    style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: agreed ? "#007bff" : "#ccc",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: agreed ? "pointer" : "not-allowed"
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default EulaPopup;